















import mixins from "@/@core/mixins";
import MixinsUtilities from "@/@modules/csov-my-holidays/services/mixins/MixinsUtilities";
import { DynamicItem } from "../interfaces/ToolbarItem";

export default mixins(MixinsUtilities).extend({
  props: {
    link: {
      type: Object as () => DynamicItem,
    },
    delete: {
      type: Boolean,
    },
    config: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      popup: "",
    };
  },
  computed: {
    deletable(): boolean {
      return !!this.delete;
    },
    label(): string | undefined {
      if (this.config) {
        if (this.config.separatorLabel) {
          const label = this.link.label?.split("|")[0].trim() as string;
          return this.ssinFormated(label, this.config.separatorLabel.indexes, this.config.separatorLabel.separator);
        }
        return this.link.label?.split("|")[0].trim();
      }
      return this.link.label;
    },
    popupLabel(): string | boolean {
      if (this.link.name) {
        if (this.config.i18n) {
          return this.$tc(this.config.i18n + this.link.name);
        }
        return this.link.name;
      } else if (this.config && this.config.i18n) {
        const linkSplited = this.link.label!.split("|");
        return this.$tc(this.config.i18n + linkSplited[linkSplited.length - 1].trim());
      }
      return false;
    },
  },
});
